import React from 'react'
import {useSelector} from 'react-redux'
import {State} from '../../reducers'
import {ROLES, esSuperusuario, obtenerRolID, tieneAlgunRol} from '../../constants/roles'

export const useSesionUsuario = () => useSelector((state: State) => state.userLogin?.datos)

export const useRolSesion = (): ROLES => obtenerRolID(useSesionUsuario())

export const useEsSuperusuario = (): boolean => esSuperusuario(useSesionUsuario())

export const useAutorizado = (roles: Array<ROLES>): boolean =>
  tieneAlgunRol(useSesionUsuario(), roles)

interface PropsAutorizado {
  roles: Array<ROLES>
  children?: React.ReactNode
  alternativa?: React.ReactNode
}

const Autorizado = ({roles, children, alternativa = null}: PropsAutorizado) => {
  const autorizado = useAutorizado(roles)
  return <React.Fragment>{autorizado ? children : alternativa}</React.Fragment>
}

export default Autorizado
